import React, { useState, useContext } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
//import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import HtmlForm from '../strategyForm/htmlForm';
import { LOCALES } from '../../i18n';
import { AppContext } from '../context';
import { KeycloackContext } from '../../services/keycloakProvider';
import StrategieForm from '../forms/StrategieForm';
import { getStrategyById, updateStrategy } from '../../services/requestHandler';

const default_color = "#8EBF55";
const highlighted_color = "#E3ED48";

export default function CarteStrategie({strategie, needReloadComponent, reloadComponent}){
    const {state} = useContext(AppContext);
    const { isAdminRole } = useContext(KeycloackContext)

    const [editStrategieFormOpen, setEditStrategieFormOpen] = useState(false);
    const strategieTemp = strategie;
    const [strategieText, setStrategieText] = useState("");

    // Highlight this particular strategy to make it stand out
    const shouldBeHighlighted = strategie.id === 75 || strategie.id === 532 || strategie.id === 536;

    const background_color = shouldBeHighlighted ? highlighted_color : default_color;

    React.useEffect(() => {
        if(state.locale === LOCALES.FRENCH) {
            setStrategieText(strategieTemp.contenu)
        }
        else if(state.locale === LOCALES.ENGLISH) {
            setStrategieText(strategieTemp.contenu_en)
        }
    },[strategieTemp, state.locale])

    // const handleBoutonClick = async (event) => {
    //   event.preventDefault();
    //   let tempStrategie = await getSpecificStrategie(strategieTemp.id)

    //   console.log("delete strategy id :" + tempStrategie)
    //   //await deleteStrategyById(strategieTemp.id)
    //needReloadComponent(!reloadComponent)
    // };

    async function getSpecificStrategie(id) {
        const data = await getStrategyById(id)
        return data;
    }

    async function handleEditStrategieClick(newStrategieInfos){
        let tempStrategie = await getSpecificStrategie(newStrategieInfos.id)
        tempStrategie.contenu = newStrategieInfos.contenu
        tempStrategie.contenu_en = newStrategieInfos.contenu_en

        await updateStrategy(tempStrategie)
        needReloadComponent(!reloadComponent)
    };

    return (
        <div style={{ marginTop: "20px"}}>
            <Card sx={{ minWidth: 600, maxWidth: 1600, backgroundColor: background_color}} >
                <CardContent style={{ display: "flex"}}>
                    <div style={{ width: "95%",  display: "flex", justifyContent: "center"}}>
                        <HtmlForm strategieTemp={strategieText}/>
                    </div>
                    <div style={{display: "grid", width: "5%"}}>
                        {/* {isAdminRole && <IconButton style={{alignSelf: "end"}} onClick={handleBoutonClick} aria-label="DeleteForever"> <DeleteForeverIcon sx={{ color: "black" }}/> </IconButton>} */}
                        {isAdminRole && <IconButton style={{alignSelf: "start"}} onClick={()=> setEditStrategieFormOpen(true)} aria-label="Edit"> <EditIcon sx={{ color: "black" }} /> </IconButton>}
                    </div>
                </CardContent>
            </Card>
            {editStrategieFormOpen && <StrategieForm
                strategie={strategie}
                open={editStrategieFormOpen}
                setOpen={setEditStrategieFormOpen}
                onConfirm={handleEditStrategieClick}
                title={"Editez la strategie"}
                description={"Veuillez remplir les cases suivantes pour editer la strategie"}
            />}
        </div>
    );
}